import { EventEmitter, Injectable } from '@angular/core';
import { AdyenPaymentDetails } from '@models/adyen.model';
import { Subject } from 'rxjs';
import { CalendarAppointmentModel } from '../../models/appointment-booking.model';
import { CouponDbModel } from '../../models/coupon-db.model';
import { PayPalOrderDetailModel } from '../../models/partner-setting.model';
import { AppointmentCartItem } from '../../models/selected-booking-data.model';

@Injectable({
  providedIn: 'root'
})
export class CustomEventService {

  refreshCalendar = new EventEmitter<void>();
  enableSubmitButtonEvent = new EventEmitter<any>();
  setWidgetConfigurationFromQueryParamsEvent = new EventEmitter<{ partner_uuid: string, widget_uuid: string }>();
  resetMainWidgetEvent = new EventEmitter<any>();
  toggleFillContainer = new EventEmitter<boolean>();
  queryStringAppointmentUuid = new EventEmitter<string>();
  resetRecurringDatesEvent: EventEmitter<boolean> = new EventEmitter();
  resetSlotSettingsEvent = new EventEmitter<any>();
  stripeSuccessfulEvent = new EventEmitter<string>();
  resetStripeTokenEvent = new EventEmitter<string | undefined>();
  stripePaymentFlowRequested = new EventEmitter<void>();
  storeBookingItemsEvent = new EventEmitter<void>();
  // Adyen. `adyenPaymentFlowRequested` is fired by payment-method-view when
  // the customer submits with Adyen selected, so Drop-in is only built (and a
  // session only minted at Adyen) when it is actually needed.
  adyenPaymentFlowRequested = new EventEmitter<void>();
  /** The shopper pressed Pay inside the Drop-in - an authorisation (possibly a 3DS2 challenge) is now in progress. */
  adyenPaymentStartedEvent = new EventEmitter<void>();
  adyenSuccessfulEvent = new EventEmitter<AdyenPaymentDetails>();
  resetAdyenEvent = new EventEmitter<string | undefined>();
  /**
   * The summary asks the Drop-in for a fresh checkout: a booking was refused AFTER the payment was
   * authorised, so that session is spent (cakephp claims it once and gives the money back) and
   * paying again needs a new one.
   */
  adyenCheckoutResetRequested = new EventEmitter<void>();
  /** The Drop-in started (true) or finished (false) loading a checkout; Book waits for it. */
  adyenCheckoutLoadingChanged = new EventEmitter<boolean>();
  /** A restored Adyen payment was already sent to /book: the summary replays that request instead of taking another payment. */
  adyenSubmittedResumeEvent = new EventEmitter<void>();
  /**
   * A booking was refused after the Friendly Captcha answer was sent with it. That answer is
   * single-use (Friendly Captcha's siteverify rejects a second use as `response_duplicate`), so the
   * payment step must collect a fresh one before the next submit.
   */
  friendlyCaptchaRenewalRequested = new EventEmitter<void>();

  paypalSuccessfulEvent = new EventEmitter<PayPalOrderDetailModel>();
  /** The customer clicked the PayPal button — a payment attempt (popup) is now in progress. */
  paypalStartedEvent = new EventEmitter<void>();
  /** The customer's PayPal attempt ended without a capture — 'cancel' (closed the popup) or 'error'. */
  paypalFailedEvent = new EventEmitter<'cancel' | 'error'>();
  resetPaypalEvent = new EventEmitter();
  couponSuccessEvent = new EventEmitter<CouponDbModel>();
  couponFailedEvent = new EventEmitter();
  removeCouponEvent = new EventEmitter();
  resetPayPalOrderDetailEvent = new EventEmitter();
  doBookingEvent = new EventEmitter();
  resetBookingButtonsEvent = new EventEmitter<void>();
  progressBarCountEvent = new EventEmitter<{ index: number, isLast: boolean }>();
  appointmentBookingDoneEvent = new EventEmitter<{ bookingData: CalendarAppointmentModel[] }>();
  refreshCalendarBadgeInBookingEvent = new EventEmitter<{ cartItems: AppointmentCartItem[] }>();
  cssOverwriteTemplateUuid = new EventEmitter<{ templateUuid: string }>();
  reloadCalendarEvent = new EventEmitter<void>();
  emptyCartEvent = new EventEmitter<void>();
}
